export default __webpack_public_path__ + "static/media/22_BlueSign.df53efc3.png";